var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4724 6.65472H11.4413V13.222H14.4724C14.6063 13.222 14.7348 13.1688 14.8296 13.074C14.9243 12.9793 14.9775 12.8508 14.9775 12.7168V7.1599C14.9775 7.02592 14.9243 6.89743 14.8296 6.80269C14.7348 6.70795 14.6063 6.65472 14.4724 6.65472V6.65472Z",
    stroke: "#707070",
    strokeWidth: 1.24351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4414 6.65471L8.91553 1.60297C8.65017 1.60297 8.38741 1.65523 8.14225 1.75678C7.89708 1.85833 7.67432 2.00718 7.48669 2.19481C7.29905 2.38245 7.1502 2.60521 7.04865 2.85038C6.9471 3.09554 6.89484 3.3583 6.89484 3.62366V5.13919H2.9876C2.84434 5.13919 2.70271 5.16965 2.57213 5.22857C2.44154 5.28748 2.32497 5.37349 2.23016 5.48089C2.13535 5.58828 2.06446 5.71462 2.0222 5.85151C1.97995 5.98839 1.96728 6.1327 1.98505 6.27485L2.74281 12.3369C2.77336 12.5813 2.89209 12.8061 3.07671 12.9691C3.26132 13.132 3.4991 13.222 3.74536 13.222H11.4414",
    stroke: "#707070",
    strokeWidth: 1.24351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.368f19cb73ee4ebc945a8faae8cda0a0.svg";
export { ForwardRef as ReactComponent };